import React from 'react';
import ServiceTripListFunctional from './components/service-trip-list-functional';

const ServiceTripList = () => {
	return <ServiceTripListFunctional />;
};

export default ServiceTripList;
